import { gql } from '@apollo/client';
const GET_PAYMENT_CALCULATIONS = gql`
  query calculatePayments($categoryPaymentInput: [CategoryPaymentInput!]!, $calculatePaymentInput: CalculatePaymentInput!) {
    calculatePayments(categoryPaymentInput: $categoryPaymentInput, calculatePaymentInput: $calculatePaymentInput)
  }
`;
export default GET_PAYMENT_CALCULATIONS;
